import React from 'react';
import {
  MUSIC_GRAPHIC_MODE_OPTIONS,
  MUSIC_READING_METHOD_OPTIONS,
  type MusicGenerationPrefs,
} from '../constants/musicAiParams';

interface MusicMethodologyPanelProps {
  value: MusicGenerationPrefs;
  onChange: (next: MusicGenerationPrefs) => void;
}

export function MusicMethodologyPanel({ value, onChange }: MusicMethodologyPanelProps) {
  return (
    <div className="space-y-4 rounded-xl border border-[var(--sala-border-strong)] bg-[var(--sala-surface-raised)] p-4">
      <p className="text-xs font-bold uppercase tracking-wider text-[var(--sala-ink-dim)]">
        Configuración de metodología musical
      </p>

      <label className="block">
        <span className="sala-label">Método de lectura</span>
        <select
          className="sala-input-dark mt-2 w-full text-sm"
          value={value.readingMethod}
          onChange={(e) =>
            onChange({
              ...value,
              readingMethod: e.target.value as MusicGenerationPrefs['readingMethod'],
            })
          }
        >
          {MUSIC_READING_METHOD_OPTIONS.map((opt) => (
            <option key={opt.id} value={opt.id} title={opt.detail}>
              {opt.label}
            </option>
          ))}
        </select>
        <p className="mt-1 text-[10px] text-[var(--sala-ink-dim)]">
          {MUSIC_READING_METHOD_OPTIONS.find((o) => o.id === value.readingMethod)?.detail}
        </p>
      </label>

      <label className="block">
        <span className="sala-label">Soporte gráfico</span>
        <select
          className="sala-input-dark mt-2 w-full text-sm"
          value={value.graphicMode}
          onChange={(e) =>
            onChange({
              ...value,
              graphicMode: e.target.value as MusicGenerationPrefs['graphicMode'],
            })
          }
        >
          {MUSIC_GRAPHIC_MODE_OPTIONS.map((opt) => (
            <option key={opt.id} value={opt.id} title={opt.detail}>
              {opt.label}
            </option>
          ))}
        </select>
        <p className="mt-1 text-[10px] text-[var(--sala-ink-dim)]">
          {MUSIC_GRAPHIC_MODE_OPTIONS.find((o) => o.id === value.graphicMode)?.detail}
        </p>
      </label>
    </div>
  );
}
